import { createSlice } from '@reduxjs/toolkit';
import { getCandidDashboard, getDashboard, getDashboardInfo, getDashUpcomingExam,getDashboardGraph,getUnattendedExamList, getDashCardCount, getCurrentMonthExams } from '../actions/dashboardAction';

interface QusPaperState {
    loading: boolean;
    dashCandidInfo: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    loading1: boolean;
    dashboardInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    dashInfo: any;
    error2: any;
    success2: boolean;
    //get question data
    loading3: boolean;
    quesPaperInfo: any;
    error3: any;
    success3: boolean;
    //get each question
    loading4: boolean;
    paperInfo: any;
    error4: any;
    success4: boolean;
    loading5:boolean;
    error5:any;
    success5:boolean;
    upcomingExamInfo:any;

    getDashboardGraphInfo:any;
    getDashboardGraphLoading:boolean;
    getDashboardGraphError:any;
    getDashboardGraphSuccess:boolean;

    getUnattendedExamListLoading:boolean;
    getUnattendedExamListError:any;
    getUnattendedExamListSuccess:boolean;
    getUnattendedExamListInfo:any;

    getDashCardCountInfo:any;   
    getDashCardCountLoading:boolean;
    getDashCardCountError:any;
    getDashCardCountSuccess:boolean;

    getCurrentMonthExamsInfo:any;
    getCurrentMonthExamsLoading:boolean;
    getCurrentMonthExamsError:any;
    getCurrentMonthExamsSuccess:boolean;

}

const initialState: QusPaperState = {
    loading: false,
    dashCandidInfo: null,
    error: null,
    success: false,
    loading1: false,
    dashboardInfo: null,
    error1: null,
    success1: false,
    loading2: false,
    dashInfo: null,
    error2: null,
    success2: false,
    //each question paper
    success3: false,
    loading3: false,
    quesPaperInfo: null,
    error3: null,
    loading4: false,
    paperInfo: null,
    error4: null,
    success4: false,
    loading5:false,
    error5:null,
    success5:false,
    upcomingExamInfo:null,
    getDashboardGraphInfo:null,
    getDashboardGraphLoading:false,
    getDashboardGraphError:null,
    getDashboardGraphSuccess:false,
    getUnattendedExamListLoading:false,
    getUnattendedExamListError:null,
    getUnattendedExamListSuccess:false,
    getUnattendedExamListInfo:null,
    getDashCardCountInfo:null,
    getDashCardCountLoading:false,
    getDashCardCountError:null,
    getDashCardCountSuccess:false,
    getCurrentMonthExamsInfo:null,
    getCurrentMonthExamsLoading:false,
    getCurrentMonthExamsError:null,
    getCurrentMonthExamsSuccess:false,
};

const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCandidDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.dashCandidInfo = null;
            })
            .addCase(getCandidDashboard.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.dashCandidInfo = payload;
                state.success = true;
            })
            .addCase(getCandidDashboard.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(getDashboardInfo.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.dashboardInfo = null;
            })
            .addCase(getDashboardInfo.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.dashboardInfo = payload;
                state.success1 = true;
            })
            .addCase(getDashboardInfo.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(getDashboard.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.dashInfo = null;
            })
            .addCase(getDashboard.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.dashInfo = payload;
                state.success2 = true;
            })
            .addCase(getDashboard.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(getDashUpcomingExam.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.upcomingExamInfo = null;
            })
            .addCase(getDashUpcomingExam.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.upcomingExamInfo = payload;
                state.success5 = true;
            })
            .addCase(getDashUpcomingExam.rejected, (state, { payload }) => {
                state.loading5 = false;
                state.error5 = payload;
                state.success5 = false;
            })
            .addCase(getDashboardGraph.pending, (state) => {
                state.getDashboardGraphLoading = true;
                state.getDashboardGraphError = null;
                state.getDashboardGraphSuccess = false;
                state.getDashboardGraphInfo = null;
            })
            .addCase(getDashboardGraph.fulfilled, (state, { payload }) => {
                state.getDashboardGraphLoading = false;
                state.getDashboardGraphInfo = payload;
                state.getDashboardGraphSuccess = true;
            })
            .addCase(getDashboardGraph.rejected, (state, { payload }) => {
                state.getDashboardGraphLoading = false;
                state.getDashboardGraphError = payload;
                state.getDashboardGraphSuccess = false;
            })
            .addCase(getUnattendedExamList.pending, (state) => {
                state.getUnattendedExamListLoading = true;
                state.getUnattendedExamListError = null;
                state.getUnattendedExamListSuccess = false;
                state.getUnattendedExamListInfo = null;
            })
            .addCase(getUnattendedExamList.fulfilled, (state, { payload }) => {
                state.getUnattendedExamListLoading = false;
                state.getUnattendedExamListInfo = payload;
                state.getUnattendedExamListSuccess = true;
            })
            .addCase(getUnattendedExamList.rejected, (state, { payload }) => {
                state.getUnattendedExamListLoading = false;
                state.getUnattendedExamListError = payload;
                state.getUnattendedExamListSuccess = false;
            })
            .addCase(getDashCardCount.pending, (state) => {
                state.getDashCardCountLoading = true;
                state.getDashCardCountError = null;
                state.getDashCardCountSuccess = false;
                state.getDashCardCountInfo = null;
            })
            .addCase(getDashCardCount.fulfilled, (state, { payload }) => {
                state.getDashCardCountLoading = false;
                state.getDashCardCountInfo = payload;
                state.getDashCardCountSuccess = true;
            })
            .addCase(getDashCardCount.rejected, (state, { payload }) => {
                state.getDashCardCountLoading = false;
                state.getDashCardCountError = payload;
                state.getDashCardCountSuccess = false;
            })
            .addCase(getCurrentMonthExams.pending, (state) => {
                state.getCurrentMonthExamsLoading = true;
                state.getCurrentMonthExamsError = null;
                state.getCurrentMonthExamsSuccess = false;
                state.getCurrentMonthExamsInfo = null;
            })
            .addCase(getCurrentMonthExams.fulfilled, (state, { payload }) => {
                state.getCurrentMonthExamsLoading = false;
                state.getCurrentMonthExamsInfo = payload;
                state.getCurrentMonthExamsSuccess = true;
            })
            .addCase(getCurrentMonthExams.rejected, (state, { payload }) => {
                state.getCurrentMonthExamsLoading = false;
                state.getCurrentMonthExamsError = payload;
                state.getCurrentMonthExamsSuccess = false;
            });
    },
});

export default dashboardSlice.reducer;